<div #chartContainer class="score-distribution-chart"></div>
